import LearningModules from "./LearningModules";
import PremiumFeatures from "./PremiumFeatures";
import MentorCard from "./MentorCard";
import StatCard from "../StatsCard"
import Button from "../Button"

const TrackLearningPlan = ({
  title,
  subtitle,
  stats,          // array of objects for StatCard
  modules,        // array for LearningModules
  premiumFeatures, // array for PremiumFeatures
  premiumButtonText,
  onBackToPrep,
  onBackToTracks, 
  mentor,         // object for MentorCard
}) => {
  return (
    <div className="container-fluid py-4">
      {/* Back Buttons */}
      <div className="mb-3">
        <Button variant="back" onClick={onBackToPrep}>← Back to Placement Prep</Button>
        <Button variant="back" onClick={onBackToTracks}>← Back to Track Selection</Button>

      </div>

      {/* Title */}
      <div className="text-center mb-4">
        <h3 className="text-light fw-bold">{title}</h3>
        <p className="text-muted-custom">{subtitle}</p>
      </div>

      {/* Stats Row */}
      <div className="row mx-0 justify-content-center mb-4">
        {stats.map((stat, idx) => (
          <StatCard
            key={idx}
            value={stat.value}
            label={stat.label}
            bg={stat.bg}
          />
        ))}
      </div>

      {/* Main Content */}
      <div className="row mx-0">
        {/* Learning Modules */}
        <LearningModules modules={modules} />

        {/* Right Column */}
        <div className="col-md-4 col-12">
          <PremiumFeatures
            features={premiumFeatures}
            buttonText={premiumButtonText}
            // onButtonClick={onPremiumClick}
          />
          <MentorCard
            title={mentor.title}
            name={mentor.name}
            role={mentor.role}
            image={mentor.image}
            rating={mentor.rating}
            // onSchedule={onScheduleMentor}
          />
        </div>
      </div>
    </div>
  );
};

export default TrackLearningPlan;